import React from 'react';
import Switch from 'react-switch';
import {LoadingIcon} from '../loadingIcon';
import PropTypes from 'prop-types';

export class ToggleSwitch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(checked) {
    this.setState({loading: true});

    this.props.onChange(checked).finally(() => {
      this.setState({loading: false});
    });
  };

  render() {
    const {onLabel, offLabel, on, ariaLabel} = this.props;
    return (
        <span className="d-flex align-items-center">
          <span aria-hidden="true">{offLabel}</span>
          <label className="mb-0"><span className="sr-only">{ariaLabel}</span>
            <Switch
                disabled={this.state.loading}
                uncheckedIcon={false}
                checkedIcon={false}
                className="mr-1 ml-2"
                onChange={this.handleChange}
                checked={on}/>
          </label>
          <span className="mr-1" aria-hidden="true">{onLabel}</span>
          <LoadingIcon display={this.state.loading}/>
         </span>
    );
  }
}

ToggleSwitch.propTypes = {
  on: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
  ariaLabel: PropTypes.string.isRequired, //label for screenreaders
};